import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import {
  DOCUMENTS,
  IRB_PRESENTATION,
  PROTOCOL_NUMBER
} from "../../../../../../constants/forms";
import FileUploadButton from "../../../../../common/Form/FileUpload/FileUploadButton";
import SubmittedDocumentsSection from "./SubmittedDocumentsSection";

const IRBSubmission: FC = (): JSX.Element => {
  const { values } = useFormikContext<FormikValues>();
  return (
    <>

      <SubmittedDocumentsSection fieldName={DOCUMENTS} />

      <Box className="mg-t-50 mg-b-50">
        <label className="form-label mg-b-20">
          2.2 MIRB Presentation{" "}
          <Typography
            variant={"subtitle1"}
            component={"span"}
            color={"secondary"}
          >
            <span className="error"> * </span>
            (As per Medanta Template)
          </Typography>
        </label>
        <FileUploadButton
          docName="MIRB Presentation"
          protocolNumber={values[PROTOCOL_NUMBER]}
          showError={true}
          name={IRB_PRESENTATION}
          label="Upload here..."
          className="mg-t-0"
        />
      </Box>
    </>
  );
};

export default IRBSubmission;
